<input #fileUploadElement
       *ngIf="!multi"
       type="file"
       accept="{{acceptedFilesString}}"
       (change)="onFilesChangeEvent($event)"
       style="display: none;"/>

<input #fileUploadElement
       *ngIf="multi"
       type="file"
       accept="{{acceptedFilesString}}"
       (change)="onFilesChangeEvent($event)"
       style="display: none;"
       multiple />

<a *ngIf="!favicon"
   mat-stroked-button
   color="accent"
   id="{{idPrefix}}btn_text.open_file_upload"
   (click)="openFileUploadWindow()">
    <span>{{ label }}</span>
</a>

<i *ngIf="favicon"
   id="{{idPrefix}}btn_icon.open_file_upload"
   class="{{favicon}}"
   matTooltip="{{ label | translate }}"
   (click)="openFileUploadWindow()">
</i>

